import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import getReadingPaneState from 'owa-calendar-reading-pane-store/lib/selectors/getReadingPaneState';
import SidePaneType from 'owa-calendar-sidepane/lib/schema/SidePaneType';
import SidePaneViewState from 'owa-calendar-meeting-forms-common-store/lib/store/schema/SidePaneViewState';
import updateSidePaneType from 'owa-calendar-meeting-forms-common-actions/lib/actions/updateSidePaneType';
import { ExtensibilityModeEnum } from 'owa-addins-types';

export const openTaskPane = (mode: ExtensibilityModeEnum) => (): void => {
    const sidePaneViewState = getSidePaneViewState(mode);
    updateSidePaneType(sidePaneViewState, SidePaneType.Addins);
};

export const closeTaskPane = (mode: ExtensibilityModeEnum) => (): void => {
    const sidePaneViewState = getSidePaneViewState(mode);
    updateSidePaneType(sidePaneViewState, SidePaneType.None);
};

function getSidePaneViewState(mode: ExtensibilityModeEnum): SidePaneViewState {
    switch (mode) {
        case ExtensibilityModeEnum.AppointmentAttendee:
            return getReadingPaneState();
        case ExtensibilityModeEnum.AppointmentOrganizer:
            return getFullComposeViewState();
        default:
            return undefined;
    }
}
